import { Button } from '@blueprintjs/core';
import {
  StatusSelect,
  StatusSelectButton,
} from 'Components/Generic/BOSSelect/StatusSelect';
import { CHARGE_ALLOCATION_STATUS } from 'Pages/Transactions/Enum';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const ChargeAllocationStatusLabel = ({
  selectedStatus,
  onSelectStatus = () => {},
  placeholder = 'Select a status',
  readOnly = false,
  disabled = false,
}) => {
  const [selectedStatusObject, setSelectedStatusObject] =
    useState(selectedStatus);

  useEffect(() => {
    selectedStatus && setSelectedStatusObject(selectedStatus);
  }, [selectedStatus]);

  const statusLabelRenderer = (statusObject) => {
    return statusObject ? (
      <StatusSelectButton
        statusObject={statusObject}
        readOnly={readOnly}
        disabled={disabled}
      />
    ) : (
      <Button intent={'primary'}>{placeholder}</Button>
    );
  };

  return readOnly || disabled ? (
    selectedStatusObject ? (
      <StatusSelectButton
        statusObject={selectedStatusObject}
        readOnly={readOnly}
        disabled={disabled}
      />
    ) : (
      <Button intent={'primary'}>{placeholder}</Button>
    )
  ) : (
    <StatusSelect
      selectedStatusObject={selectedStatusObject}
      onSelectStatus={onSelectStatus}
      statusObjectList={Object.values(CHARGE_ALLOCATION_STATUS)}
    />
  );
};

ChargeAllocationStatusLabel.propTypes = {
  selectedStatus: PropTypes.object.isRequired,
  onSelectStatus: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default ChargeAllocationStatusLabel;
